module.exports = __webpack_public_path__ + "img/3.6229303b.png";